import { Component } from "@builder.io/sdk";

export const twoColumnTextConfig: Component = {
  name: "Two Column Text",
  inputs: [
    {
      name: "id",
      type: "string",
      advanced: true,
      defaultValue: "two-column-text",
      helperText:
        "Unique identifier for the section. Useful for linking to the section by '#id'.",
    },
    {
      name: "left",
      type: "object",
      subFields: [
        {
          name: "title",
          type: "string",
          defaultValue: "Medication Management, Administration, and Injection",
          helperText: "Title for the left column",
          required: true,
        },
        {
          name: "description",
          type: "richText",
          defaultValue:
            "Our nurses deliver high-quality service with accurate administration techniques, ensuring safety and effectiveness. With Care Indeed, you receive professional medical assessments, monitoring for reactions, and evaluating medication effectiveness. We also offer patient and family education sessions and resources. Managing medication at home can be challenging, but with Care Indeed, you can trust in our expertise and dedication to your health and well-being.",
          helperText: "Content for the left column",
          required: true,
        },
      ],
    },
    {
      name: "right",
      type: "object",
      subFields: [
        {
          name: "title",
          type: "string",
          defaultValue:
            "Post Surgery (Tracheostomy, Nasogastric Tube Care, Gastrostomy)",
          helperText: "Title for the right column",
          required: true,
        },
        {
          name: "description",
          type: "richText",
          defaultValue:
            "Our skilled nurses provide professional medical assessments, monitor for signs of infection, displacement, or blockage, and use sterile techniques for cleaning and medication administration. For tracheostomy care, we ensure proper suctioning and cleaning protocols. Our nasogastric care includes tube flushing and fluid/feed rate monitoring, while gastrostomy care involves sterile cleaning and medication or feed administration. Beyond medical care, we empower patients and families to confidently manage post-surgery maintenance and care routines.",
          helperText: "Content for the right column",
          required: true,
        },
      ],
    },
  ],
};
